import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid } from '@mui/material';

import { LinearLoading } from 'common'

export const FormHouses = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen
    
    const { fetchSpecificHouse } = FetchData
    const { loadingFetchSpecificHouse } = fetchSpecificHouse

    const { onSubmitForm, handleClickHideForm } = Actions

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idusuario > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificHouse && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="descripcion_corta"
                                        name="descripcion_corta"
                                        value={formState.descripcion_corta}
                                        onChange={onInputChange}
                                        label='Descripción corta'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="descripcion_larga"
                                        name="descripcion_larga"
                                        label="Descripción larga"
                                        value={formState.descripcion_larga}
                                        onChange={onInputChange}
                                        size='small'
                                        multiline
                                        rows={3}
                                        type="text"
                                        variant="standard"
                                        InputProps={{ readOnly: false }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="direccion"
                                        name="direccion"
                                        value={formState.direccion}
                                        onChange={onInputChange}
                                        label='Dirección'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="costo_alquiler"
                                        name="costo_alquiler"
                                        value={formState.costo_alquiler}
                                        onChange={onInputChange}
                                        label='Costo de alquiler'
                                        size='small'
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
